//Import Swiper assets
import Swiper from "swiper/bundle";

const centerPaginationDots = (swiper) => {
	if (window.innerWidth <= 782) {
		// centered slides arrows below e.g. /plan-your-trip/ slider
		if (swiper.el.dataset.centeredslides === "1" 
			&& swiper.el.parentElement.classList.contains('slider-arrows-below')
		) {
			const offset = window.innerWidth <= 350 ? `-250%` : `-200%`;
			swiper.pagination.bullets.forEach(b => b.style.translate = offset);
		} 

		// non centered slides arrows below e.g. /visitor-information/ slider
		if (swiper.el.dataset.centeredslides != "1" 
			&& swiper.el.parentElement.classList.contains('slider-arrows-below')
			&& swiper.pagination.el
		) {
			swiper.pagination.el.style.justifyContent = "center";
		}

		// centered slides arrows beside
		if (swiper.el.dataset.centeredslides === "1" 
			&& swiper.el.parentElement.classList.contains('slider-arrows-sides')
		) {
			swiper.pagination.bullets.forEach(b => b.style.translate = `-200%`);
		}
	} else {
		swiper.pagination.bullets.forEach(b => b.style.translate = ``);
	}
}

export function initSwiperSliders(slider = null, options = {}) {
	if (slider && slider.swiper) {
		//slider.swiper.destroy();
	}

	//console.log(slider);
	//console.log(options);

	let adminSlider = options?.adminSlider ?? false;

	//pagination & nav elements
	let navWrapper = slider.nextElementSibling;

	let paginationEl;
	let navPrevEl;
	let navNextEl;
	let scrollbarEl;

	if (navWrapper) {
		paginationEl 	= navWrapper.querySelector(".swiper-pagination");
		navPrevEl 		= navWrapper.querySelector(".swiper-button-prev");
		navNextEl 		= navWrapper.querySelector(".swiper-button-next");
		scrollbarEl 	= navWrapper.querySelector(".swiper-scrollbar");
	}

	let setAutoHeight = slider.dataset.enablegridrows ? false : true;
	//autoheight hates the block editor
	if (adminSlider) {
		setAutoHeight =
			slider.dataset.sliderdirectiondesktop === "vertical" ? true : false;
	}

	let swiperslider = new Swiper(slider, {
		simulateTouch: adminSlider ? false : true,
		autoHeight: setAutoHeight,
		mousewheel: {
			enabled: slider.dataset.enablemousescroll ? true : false,
			releaseOnEdges: true,
		},

		//general settings
		initialSlide: slider.dataset.initialslide ?? 0,
		autoplay: slider.dataset.enableautoplay ? true : false,
		centeredSlides: slider.dataset.centeredslides ? true : false,
		effect: slider.dataset.effect ?? "slide",
		loop: slider.dataset.loop ? true : false,
		loopPreventsSliding: false,
		loopAdditionalSlides: 1,
		loopAddBlankSlides: true,
		freeMode: {
			enabled: slider.dataset.freemode ? true : false,
		},

		//navigation settings
		navigation: slider.dataset.enablearrownavigation
			? {
					nextEl: navNextEl,
					prevEl: navPrevEl,
			  }
			: false,
		pagination: slider.dataset.enablepagination
			? {
					el: paginationEl,
					type: "bullets",
					clickable: true,
			  }
			: false,
		scrollbar: slider.dataset.enablescrollbar
			? {
					el: scrollbarEl,
					draggable: true,
			  }
			: false,

		direction: slider.dataset.sliderdirectionmobile,

		//responsive settings
		grid: {
			rows: slider.dataset.enablegridrows
				? Number(slider.dataset.gridrowsmobile)
				: 1,
			fill: "row",
		},
		spaceBetween: slider.dataset.enablespacebetween
			? Number(slider.dataset.spacebetweenmobile)
			: 0,
		slidesPerGroup: slider.dataset.enableslidespergroup
			? Number(slider.dataset.slidespergroupmobile)
			: 1,
		slidesPerGroupAuto: slider.dataset.enableslidespergroupauto ? true : false,
		slidesPerView: slider.dataset.enableslidesperview
			? slider.dataset.enableslidesperviewauto
				? "auto"
				: Number(slider.dataset.slidesperviewmobile)
			: 1,
		breakpoints: {
			782: {
				direction: slider.dataset.sliderdirectiontablet,
				grid: {
					rows: slider.dataset.enablegridrows
						? Number(slider.dataset.gridrowstablet)
						: 1,
				},
				spaceBetween: slider.dataset.enablespacebetween
					? Number(slider.dataset.spacebetweentablet)
					: 0,
				slidesPerGroup: slider.dataset.enableslidespergroup
					? Number(slider.dataset.slidespergrouptablet)
					: 1,
				slidesPerView: slider.dataset.enableslidesperview
					? slider.dataset.enableslidesperviewauto
						? "auto"
						: Number(slider.dataset.slidesperviewtablet)
					: 1,
			},
			980: {
				direction: slider.dataset.sliderdirectiondesktop,
				grid: {
					rows: slider.dataset.enablegridrows
						? Number(slider.dataset.gridrowsdesktop)
						: 1,
				},
				spaceBetween: slider.dataset.enablespacebetween
					? Number(slider.dataset.spacebetweendesktop)
					: 0,
				slidesPerGroup: slider.dataset.enableslidespergroup
					? Number(slider.dataset.slidespergroupdesktop)
					: 1,
				slidesPerView: slider.dataset.enableslidesperview
					? slider.dataset.enableslidesperviewauto
						? "auto"
						: Number(slider.dataset.slidesperviewdesktop)
					: 1,
			},
		},

		//other settings
		observer: true,
		observeParents: true,
		observeSlideChildren: true,

		//used in block editor
		slideClass: options?.slideClass ?? "swiper-slide",
		wrapperClass: options?.wrapperClass ?? "swiper-wrapper",

		// Effect Settings 
		coverflowEffect: {
			rotate: 0,
			stretch: 80,
			depth: 200,
			modifier: 1,
			slideShadows: false,
		},

		//slider events
		on: {
			'slideChange': function(swiper) {
				// respect user preferences for scroll behavior
				const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

				if (window.innerHeight < 600) {
					const mediaText = slider.querySelector('.wp-block-media-text');

					// when using the media text custom slider
					if (slider.parentElement.classList.contains('slider-type-custom') && mediaText) {
					
						// scroll to the title
						const title = mediaText.querySelectorAll('.post-title, .wp-block-heading')?.[0];
						title && title.scrollIntoView({ 
							behavior
						});
					}
				}

				centerPaginationDots(swiper);
			},
			'resize': (swiper) => {
				centerPaginationDots(swiper);

				if (window.innerWidth <= 782 && swiper.params.pagination.dynamicBullets === false) {
					swiper.params.pagination.dynamicBullets = true;
					swiper.pagination.el.classList.add('swiper-pagination-bullets-dynamic');

					swiper.pagination.init();
					swiper.pagination.update();
				} else if (window.innerWidth > 782 && swiper.params.pagination.dynamicBullets === true) {
					swiper.params.pagination.dynamicBullets = false;
					swiper.pagination.init();
					swiper.pagination.update();

					swiper.pagination.el.classList.remove('swiper-pagination-bullets-dynamic');
					swiper.pagination.el.style.width = "";
					swiper.pagination.bullets.forEach(b => b.style.left = "");
				}
				
			}
		}
	});

	//console.log(swiperslider.passedParams);
	//console.log(swiperslider.slides);

	return swiperslider;
}
